/* Mariposa combined-store logic: PDP default offer, add-to-cart race fix,
   card price display. Vanilla JS, no dependencies.

   The shopper's path is resolved server-side in Liquid and stamped on <html>
   as data-mariposa-path. This file reads it; it never sets it. Writing the path
   belongs to mariposa-path.js, which owns the entry gate and the switcher.
   See DESIGN-PATH-MODEL.md. */
(function () {
  'use strict';

  /* The path is decided in Liquid and rendered onto <html>. Read only. */
  function getMode() {
    var p = document.documentElement.getAttribute('data-mariposa-path') || '';
    return (p === 'pickup' || p === 'mail') ? p : '';
  }

  /* On PDP: pre-select the offer matching the locked path, unless the URL
     pinned a variant. Never swaps cart contents (edge case 3).
     Phase 2 removes the losing offer server-side; until then this selects it. */
  function applyPdpDefault(mode) {
    if (!mode) return;
    if (/[?&]variant=/.test(location.search)) return;
    var want = mode === 'pickup' ? 'Pickup' : 'Mail Order';
    var radios = document.querySelectorAll('input[type="radio"][data-option-name="Fulfillment"]');
    for (var i = 0; i < radios.length; i++) {
      var r = radios[i];
      if (r.value.indexOf(want) === 0) {
        if (!r.checked && !r.classList.contains('disabled')) {
          r.checked = true;
          r.dispatchEvent(new Event('change', { bubbles: true }));
        }
        return;
      }
    }
  }

  /* ---- Add-to-cart race fix (test report bug 2) ----
     Dawn only commits the variant id to the form's hidden input after a
     section-render round-trip, disabling Add-to-cart in between; a fast click
     either no-ops or posts the stale default variant. The Fulfillment radios
     carry data-target-variant-id (resolved server-side), so we commit the id
     synchronously on change, re-enable the button, and re-assert the id one
     last time at submit. Dawn's async refresh lands later with the same id. */
  function formForRadio(radio) {
    var fid = radio.getAttribute('form');
    return (fid && document.getElementById(fid)) || radio.closest('form');
  }

  function syncVariantId(radio) {
    var tid = radio.dataset.targetVariantId;
    var form = formForRadio(radio);
    if (!tid || !form) return;
    var input = form.querySelector('input[name="id"]');
    if (!input) return;
    input.value = tid;
    input.disabled = false;
    var available = radio.dataset.targetAvailable !== 'false';
    // B2B pickup-only block outranks the race-fix re-enable. Read it off THIS
    // form's submit button, which Dawn re-renders on every variant change
    // (product-info.js:214-219). It used to query [data-mariposa-b2b-mail-blocked]
    // anywhere in the document — a paragraph nothing ever refreshes — so one
    // blocked render disabled this path for the life of the page.
    if (form.querySelector('button[name="add"][data-mariposa-blocked]')) return;
    var enable = function () {
      // the id input may have been re-rendered by Dawn's refresh — re-assert
      var i2 = form.querySelector('input[name="id"]');
      if (i2) { i2.value = tid; i2.disabled = false; }
      var pf = form.closest('product-form');
      if (pf && typeof pf.toggleSubmitButton === 'function') {
        pf.toggleSubmitButton(!available);
      } else {
        var btn = form.querySelector('button[type="submit"][name="add"]');
        if (btn) btn.toggleAttribute('disabled', !available);
      }
    };
    // run after the current change dispatch: Dawn's own listener (bubble phase)
    // disables the button for its background section refresh — with the id
    // already committed there is nothing to wait for, so re-enable immediately
    enable();
    setTimeout(enable, 0);
  }

  /* The per-variant note used to be toggled here, by hiding one div per variant.
     Removed 2026-09-01: that markup sat outside every region the Section Rendering
     API replaces, so these toggles were the only thing holding it correct, racing
     the fetch on a timer. It is now rendered server-side for the resolved variant
     into #Variant-Note-<section.id> and swapped by product-info.js with the price. */

  function checkedFulfillmentRadio(form) {
    var radios = document.querySelectorAll('input[data-option-name="Fulfillment"][data-target-variant-id]');
    for (var i = 0; i < radios.length; i++) {
      if (radios[i].checked && formForRadio(radios[i]) === form) return radios[i];
    }
    return null;
  }

  function showAddToast() {
    var t = document.querySelector('.mariposa-add-toast');
    if (!t) {
      t = document.createElement('div');
      t.className = 'mariposa-add-toast';
      t.setAttribute('role', 'status');
      t.style.cssText = 'position:fixed;bottom:1.5rem;left:50%;transform:translateX(-50%);z-index:1000;' +
        'background:#3a3a3a;color:#fff;padding:0.9rem 1.4rem;border-radius:4px;font-size:1.4rem;' +
        'box-shadow:0 4px 14px rgba(0,0,0,.25);transition:opacity .3s;';
      t.innerHTML = '✓ Added to cart &nbsp;<a href="/cart" style="color:#fff;text-decoration:underline;">View cart</a>';
      document.body.appendChild(t);
    }
    t.style.opacity = '1';
    clearTimeout(t._hide);
    t._hide = setTimeout(function () { t.style.opacity = '0'; }, 4000);
  }

  function initAddToCartSync() {
    // capture phase: runs before Dawn's own handlers
    document.addEventListener('change', function (e) {
      if (e.target && e.target.matches &&
          e.target.matches('input[data-option-name="Fulfillment"][data-target-variant-id]')) {
        syncVariantId(e.target);
      }
    }, true);


    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form.matches || !form.matches('form[data-type="add-to-cart-form"]')) return;
      var radio = checkedFulfillmentRadio(form);
      if (radio) {
        var input = form.querySelector('input[name="id"]');
        if (input && input.value !== radio.dataset.targetVariantId) {
          input.value = radio.dataset.targetVariantId;
          input.disabled = false;
        }
      }
    }, true);

    // sync once on load too — Dawn disables Add during the refresh triggered by
    // our mode-default radio pre-select; committing the id lets us re-enable now
    var checked = document.querySelector('input[data-option-name="Fulfillment"][data-target-variant-id]:checked');
    if (checked) syncVariantId(checked);

    // visible add confirmation: the cart drawer opens itself; toast is the
    // fallback when no drawer element is on the page.
    // NOTE: Dawn's PUB_SUB_EVENTS is a top-level const (not a window property) —
    // reference it bare, with the literal event name as fallback.
    if (typeof window.subscribe === 'function') {
      var cartUpdateEvt = (typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) || 'cart-update';
      window.subscribe(cartUpdateEvt, function (d) {
        if (!d || d.source !== 'product-form') return;
        if (document.querySelector('cart-drawer')) return;
        showAddToast();
      });
    }
  }

  function init() {
    initAddToCartSync();
    var mode = getMode();
    applyPdpDefault(mode);
  }

  window.MariposaMode = { get: getMode };

  /* The sticky header offsets itself below the mode bar (see .section-header
     in mariposa.css); the bar's height varies when it wraps on narrow screens. */
  function setBarHeight() {
    var bar = document.querySelector('.mb-switch');
    document.documentElement.style.setProperty('--mb-bar-h', bar ? bar.offsetHeight + 'px' : '0px');
  }
  window.addEventListener('resize', setBarHeight);
  document.addEventListener('DOMContentLoaded', setBarHeight);
  setBarHeight();

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();


/* Minimum-quantity clamp (Eileen's deck slide 6; audit 8/31 check D2).
   The min attribute stops the stepper buttons but the theme submits carts via
   fetch, so a TYPED value below the minimum sailed through. Clamp on commit
   (change) and once more when an add-to-cart is pressed, so the submitted
   quantity can never be below the input's min. */
(function () {
  function clampMin(input) {
    var min = parseInt(input.getAttribute('min'), 10);
    if (!min || min <= 1) return;
    var val = parseInt(input.value, 10);
    if (isNaN(val) || val < min) input.value = min;
  }
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (t && t.matches && t.matches('input[name="quantity"]')) clampMin(t);
  }, true);
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('button[name="add"]');
    if (!btn) return;
    var form = btn.form || btn.closest('form');
    if (!form) return;
    var qty = form.querySelector('input[name="quantity"]') ||
      document.querySelector('input[name="quantity"][form="' + form.id + '"]');
    if (qty) clampMin(qty);
  }, true);
})();

/* Mobile product page: description below Add to cart, and a bottom bar with the price and Add to cart while the page's own button is out of
   view (Tom 2026-10-26; on phones Add to cart sat 1.5-2 screens down). It presses the real button, so
   the form's own checks and the cart drawer work exactly as before. Hidden at 750px and wider (CSS). */
(function () {
  var real = document.querySelector('product-info[id^="MainProduct-"] button[name="add"]');
  if (!real || !window.IntersectionObserver) return;
  var info = real.closest('product-info');

  // Under 750px the description goes below Add to cart so price and button come first; a marker
  // keeps its desktop spot. Moving the node (not CSS order) keeps the theme's spacing as it was.
  var mq = window.matchMedia('(max-width: 749px)');
  var box = info.querySelector('.product__info-container');
  var desc = box && box.querySelector(':scope > .product__description');
  var home = desc && document.createComment('mb-description');
  if (desc) desc.parentNode.insertBefore(home, desc);
  function place() {
    if (!desc) return;
    if (mq.matches) {
      var next = box.querySelector(':scope > .mariposa-food-content') || box.querySelector(':scope > share-button');
      if (next) box.insertBefore(desc, next); else box.appendChild(desc);
    } else {
      home.parentNode.insertBefore(desc, home.nextSibling);
    }
  }
  place();
  if (mq.addEventListener) mq.addEventListener('change', place);
  var bar = document.createElement('div');
  bar.className = 'mb-sticky-atc';
  bar.innerHTML = '<span class="mb-sticky-atc__price"></span><button type="button" class="button mb-sticky-atc__btn"></button>';
  document.body.appendChild(bar);
  var price = bar.querySelector('.mb-sticky-atc__price');
  var btn = bar.querySelector('.mb-sticky-atc__btn');
  function sync() {
    // The amount the shopper sees: sale price when on sale, else the regular price (the theme's
    // .price also holds screen-reader labels such as "Regular price", so read the item itself).
    var p = info.querySelector('.price');
    var item = p && (p.classList.contains('price--on-sale') ? p.querySelector('.price__sale .price-item--sale') : p.querySelector('.price__regular .price-item--regular'));
    price.textContent = item ? item.textContent.trim() : '';
    btn.textContent = (real.innerText || '').trim() || 'Add to cart';
    btn.disabled = real.disabled || real.getAttribute('aria-disabled') === 'true';
  }
  new IntersectionObserver(function (entries) {
    sync();
    bar.classList.toggle('is-on', !entries[0].isIntersecting);
  }).observe(real);
  btn.addEventListener('click', function () {
    real.scrollIntoView({ block: 'center', behavior: 'smooth' });
    real.click();
  });
})();
